import {faDownload} from "@fortawesome/pro-solid-svg-icons/faDownload";
import {faPaperclip} from "@fortawesome/pro-solid-svg-icons/faPaperclip";
import {faTrash} from "@fortawesome/pro-solid-svg-icons/faTrash";
import {Button, ColourSolid, ItemRow} from "@twigsby/frontend-framework";
import {FormProvider, useForm} from "@twigsby/frontend-framework/lib/ReactHookForm";
import {FormatLocaleDateTime} from "@twigsby/helpers";
import React, {useState} from "react";
import {useForwardingBatchProvider} from "../../../Providers/ForwardingBatchProvider";
import {BatchDocumentEntriesType, RenderBatchSectionType} from "../../../Types/ForwardingBatchTypes";
import {AddDocumentToBatchModal} from "../Modals/AddDocumentToBatchModal";

const BatchDocuments = (props: RenderBatchSectionType) => {
    const [ addDocumentModalOpen, setAddDocumentModalOpen ] = useState<boolean>(false);
    const { currentBatchData, RemoveDocumentFromBatch } = useForwardingBatchProvider();

    const formMethods = useForm({
        defaultValues: {
            shippingDocuments:  currentBatchData?.shippingDocuments,
        },
        mode: "onChange"
    });

    const HandleRemoveDocument = (documentId: any) => {
        RemoveDocumentFromBatch(documentId);
    }

    if(props.complete) return <BatchDocumentsComplete {...props} />;

    return (
        <FormProvider {...formMethods}>
            <div>
                <h5 className={'mb-xs'}>{`Step ${props.sectionIndex}: ${props.section.name}`} {props.section.isOptional ?
                    <span className="fade">(Optional)</span> : ''}</h5>

                <p>You can provide us with documents that will help us ship your batch.</p>

                <BatchDocumentsEntries {...props} removeDocumentCallback={(id) => HandleRemoveDocument(id)} />

                <Button
                    title={'Attach Document'}
                    icon={faPaperclip}
                    colour={ColourSolid.Primary}
                    fullWidth={true}
                    onClick={() => setAddDocumentModalOpen(true)}
                    disabled={props.readOnly}
                />

                <AddDocumentToBatchModal
                    isOpen={addDocumentModalOpen}
                    closeCallback={() => setAddDocumentModalOpen(false)}
                />
            </div>
        </FormProvider>
    )
}

const BatchDocumentsEntries = (props: BatchDocumentEntriesType) => {
    const { currentBatchData } = useForwardingBatchProvider();

    return (
        <>
            {currentBatchData && currentBatchData?.shippingDocuments.length > 0 && (
                <div className={'card mb-md fb-document-rows'}>
                    {currentBatchData.shippingDocuments.map((document, index) =>
                        <ItemRow
                            key={`shippingDocument${index}`}
                            static={true}
                        >
                            <div>{document.file.fileName}</div>
                            <div>{document.shippingDocumentType}</div>
                            <div>{FormatLocaleDateTime(document.dateCreated)}</div>
                            <div className={'ml-a'}>
                                <div className={`${!props.complete ? 'btn-group m-0' : ''}`}>
                                    {document.file.linkToFile && document.file.linkToFile !== '' && (
                                        <Button title={'Download'} icon={faDownload}/>
                                    )}
                                    {!props.complete && (
                                        <Button
                                            title={'Delete'}
                                            icon={faTrash}
                                            onClick={() => props.removeDocumentCallback(document.id)}
                                            disabled={props.readOnly}
                                        />
                                    )}
                                </div>
                            </div>
                        </ItemRow>
                    )}
                </div>
            )}
        </>
    )
}

const BatchDocumentsComplete = (props: RenderBatchSectionType) => {
    const {currentBatchData} = useForwardingBatchProvider();

    if (currentBatchData?.shippingDocuments.length === 0) return <></>;

    return (
        <div>
            <h5 className={'mb-xs'}>{props.section.name}</h5>

            <BatchDocumentsEntries {...props} removeDocumentCallback={() => null}/>
        </div>
    )
}

export {BatchDocuments}
